import { IotaProvider } from './IotaProvider';

export function getConnectedIotaProvider(): IotaProvider {
  return IotaProvider.getInstance();
}
